Vendd.Scripts.load(function () {

    $('.x-control[data-control="pager"][data-type="combopages"]').each(function (i, item) {
        var $wrapper = $(this);

        var isPagerAjax = $wrapper.data('ajax');
        var pageSelectBox = $wrapper.find('.paging select');

        if (isPagerAjax) {

            var connectedList = $wrapper.data('list');
            if (connectedList === undefined)
                throw 'Connected list not declared for pager ' + $wrapper.attr('id');

            var $connectedList = $('.x-control[data-control="list"][data-list="' + connectedList + '"]').first();
            var $pageLinks = $wrapper.find('.paging a[data-pager-link]');

            pageSelectBox.change(function (e) {
                var config = $connectedList.get(0).getConfiguration();
                config.LoaderData.PageNumber = parseInt($(this).find(":selected").attr('value'));
                $connectedList.get(0).load(config);
            });

            $pageLinks.click(function (e) {
                e.preventDefault();

                if (!$(this).hasClass('inactive')) {
                    var config = $connectedList.get(0).getConfiguration();
                    config.LoaderData.PageNumber = parseInt($(this).data('page'));
                    $connectedList.get(0).load(config);
                }
            });

            $connectedList.get(0).bind('dataload', function (control, response) {
                var currentConfig = $connectedList.get(0).getConfiguration();

                var pageNumber = currentConfig.LoaderData.PageNumber;
                var pageSize = currentConfig.LoaderData.PageSize;
                var pageCount = Math.ceil(response.Data.ItemsCount / pageSize);

                var itemStart = ((pageNumber * pageSize) - pageSize) + 1;
                var itemStop = (itemStart - 1) + response.Data.Items.length;
                var itemCount = response.Data.ItemsCount;

                $wrapper.find('*[data-pager-itemstart]').html(itemStart);
                $wrapper.find('*[data-pager-itemstop]').html(itemStop);
                $wrapper.find('*[data-pager-itemcount]').html(itemCount);

                $wrapper.find('*[data-pager-pagenumber]').html(pageNumber);
                $wrapper.find('*[data-pager-pagesize]').html(pageSize);
                $wrapper.find('*[data-pager-pagecount]').html(pageCount);

                var $selectBox = $wrapper.find('.paging select');

                if ($selectBox.children('option').length !== pageCount) {
                    $selectBox.children('option').remove();

                    for (var p = 0; p < pageCount; p++) {
                        var pN = p + 1;
                        var $option = $('<option />')
                            .attr('value', pN)
                            .html(pN);

                        $option.data('url', '#');

                        if (pN === pageNumber)
                            $option.attr('selected', 'selected');

                        $selectBox.append($option);
                    }
                }

                if ($selectBox.children('option[selected="selected"]').attr('value') !== String(pageNumber)) {
                    $selectBox.children('option').removeAttr('selected');
                    $selectBox.children('option[value="' + pageNumber + '"]').attr('selected', 'selected');
                }

                var $firstPageLink = $wrapper.find('.paging a.first');
                $firstPageLink.data('page', 1);
                if (pageNumber < 2 && !$firstPageLink.hasClass('inactive'))
                    $firstPageLink.addClass('inactive');
                else
                    if ($firstPageLink.hasClass('inactive'))
                        $firstPageLink.removeClass('inactive');

                var $previousPageLink = $wrapper.find('.paging a.previous');
                $previousPageLink.data('page', pageNumber - 1);
                if (pageNumber < 2 && !$previousPageLink.hasClass('inactive'))
                    $previousPageLink.addClass('inactive');
                else
                    if ($previousPageLink.hasClass('inactive'))
                        $previousPageLink.removeClass('inactive');

                var $nextPageLink = $wrapper.find('.paging a.next');
                $nextPageLink.data('page', pageNumber + 1);
                if (pageNumber >= pageCount && !$nextPageLink.hasClass('inactive'))
                    $nextPageLink.addClass('inactive');
                else
                    if ($nextPageLink.hasClass('inactive'))
                        $nextPageLink.removeClass('inactive');

                var $lastPageLink = $wrapper.find('.paging a.last');
                $lastPageLink.data('page', pageCount);
                if (pageNumber >= pageCount && !$lastPageLink.hasClass('inactive'))
                    $lastPageLink.addClass('inactive');
                else
                    if ($lastPageLink.hasClass('inactive'))
                        $lastPageLink.removeClass('inactive');
            });

        }
        else {
        	pageSelectBox.change(function (e) {
        		if (pageSelectBox.hasClass('disabled')) return;
        		var element = $('.x-product-list li[data-page="' + $(this).find(":selected").val() + '"]');
        		if (element.length > 0) {
        			$('html,body').animate({ scrollTop: element.eq(0).offset().top - 100 }, 600);
        			return;
        		}
        		document.location = $(this).find(":selected").data('url');
        	});
        }

    });

});